export default __webpack_public_path__ + "static/media/EXEMPLO 1.2df0e55c.jpg";